import { CrewClaimResolutionMethodEnum } from 'corso-types';
import { FC } from 'react';
import { TransformableResolutionMethod } from '~/features/claimReview/ClaimReviewProvider';
import { UnsafeContextError } from '~/utils/unsafeContextError';
import MonetaryModifier from './MonetaryModifier';
import RepairModifier from './RepairModifier';
import ReplacementOrderModifier from './ReplacementOrderModifier';
import { ResolutionModifierProps } from './types';
import VariantExchangeModifier from './VariantExchangeModifier';

/** Connection of resolvable resolution methods to components that can create the related resolution after human input. */
export const resolutionModifier = {
  [CrewClaimResolutionMethodEnum.refund]: ({
    claimLineItem,
    onCancel,
    onSave,
  }) => (
    <MonetaryModifier
      resolutionMethod={CrewClaimResolutionMethodEnum.refund}
      claimLineItem={claimLineItem}
      onCancel={onCancel}
      onSave={onSave}
    />
  ),
  [CrewClaimResolutionMethodEnum.giftCard]: ({
    claimLineItem,
    onCancel,
    onSave,
  }) => (
    <MonetaryModifier
      resolutionMethod={CrewClaimResolutionMethodEnum.giftCard}
      claimLineItem={claimLineItem}
      onCancel={onCancel}
      onSave={onSave}
    />
  ),
  [CrewClaimResolutionMethodEnum.replacementOrder]: ({
    claimLineItem,
    onCancel,
    onSave,
  }) => (
    <ReplacementOrderModifier
      claimLineItem={claimLineItem}
      onCancel={onCancel}
      onSave={onSave}
    />
  ),
  [CrewClaimResolutionMethodEnum.variantExchange]: ({
    claimLineItem,
    onCancel,
    onSave,
  }) => (
    <VariantExchangeModifier
      claimLineItem={claimLineItem}
      onCancel={onCancel}
      onSave={onSave}
    />
  ),
  [CrewClaimResolutionMethodEnum.repair]: ({
    claimLineItem,
    onCancel,
    onSave,
  }) => (
    <RepairModifier
      claimLineItem={claimLineItem}
      onCancel={onCancel}
      onSave={onSave}
    />
  ),
  [CrewClaimResolutionMethodEnum.other]: ({ claimLineItem }) => {
    throw new UnsafeContextError(
      `${CrewClaimResolutionMethodEnum.other} is not supported in the UI for modification. This should've been locked/blocked for edits.`,
      {
        claimLineItem,
      },
    );
  },
} as const satisfies Record<
  TransformableResolutionMethod,
  FC<ResolutionModifierProps>
>;
